<template>
    <section class="property-filterlink" :class="{'show-more': showMore2}" comp="propertyFilterlink">
        <div class="f2 text-bold">Narrow your search</div>
        <div class="property-linklist">
            <a v-if="glb?.listingCountObj['city']?.homeOpenCount > 0" :href="`${glb.appUrl}${dpp.geo.cityPath}open-houses/`">{{ dpp.geo.city }} <b>open houses</b></a>
            <a v-if="glb?.listingCountObj['city']?.singleFamilyCount > 0" :href="`${glb.appUrl}${dpp.geo.cityPath}single-family/`">{{ dpp.geo.city }} <b>single family</b> homes for sale</a>
            <a v-if="glb?.listingCountObj['city']?.condoCount > 0" :href="`${glb.appUrl}${dpp.geo.cityPath}condos/`">{{ dpp.geo.city }} <b>condos and townhomes</b> for sale</a>
            <a :href="`${glb.appUrl}${dpp.geo.cityPath}multi-family/`">{{ dpp.geo.city }} <b>multi-family and duplexes</b> for sale</a>
            <a :href="`${glb.appUrl}${dpp.geo.cityPath}land/`">{{ dpp.geo.city }} <b>lots and land</b> for sale</a>
            <a :href="`${glb.appUrl}${dpp.geo.cityPath}mobile/`">{{ dpp.geo.city }} <b>mobile and manufactured</b> homes for sale</a>
            <a :href="`${glb.appUrl}${dpp.geo.cityPath}sold/`">{{ dpp.geo.city }} <b>recently sold</b> homes</a>
            <a :href="`${glb.appUrl}${dpp.geo.cityPath}foreclosed/`">{{ dpp.geo.city }} <b>foreclosed</b> homes for sale</a>
            <a :href="`${glb.appUrl}${dpp.geo.cityPath}rentals/`">{{ dpp.geo.city }} <b>rentals</b></a>
            <a :href="`${glb.appUrl}${dpp.geo.cityPath}rentals/single-family/`">{{ dpp.geo.city }} <b>single family</b> for rent</a>
            <a :href="`${glb.appUrl}${dpp.geo.cityPath}rentals/condos/`">{{ dpp.geo.city }} <b>apartments</b> for rent</a>
        </div>
        <button type="button" @click="toggleShowMore2">{{ showMore2 ? 'Show Less' : 'Show More' }} <i :class="showMore2 ? 'icon-angle-up' : 'icon-angle-down'"></i></button>
    </section>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'propertyGeoFilterLink',
    data() {
        return {
            showMore2: false,
        };
    },
    methods: {
        toggleShowMore2() {
            this.showMore2 = !this.showMore2;
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp']),
    },
};
</script>
